<template>
  <div>

     <div class="filter-header">
       <i class="icon-fanhui icon iconfont" @click="returnPage"></i>
       <span class="area">{{ department[group[0]] }}</span>
       <span class="time">{{begin_time}}-{{end_time}}</span>
       <i class="icon iconfont icon-shaixuan" @click="filter"></i>
     </div>

     <ul class="field-wrappwe three">
      
       <li class="field-item">
         <p class="item-value"> <span class="symbol">¥</span>{{ data.have_wait_money == undefined ? '' : Number(data.have_wait_money).toFixed(2)}} <span class="unit">(万)</span></p>
         <p class="item-name active">已开发票待回款</p>
       </li>

       <li class="field-item">
         <p class="item-value"> <span class="symbol">¥</span>{{ data.all_back_money == undefined ? '' : Number(data.all_back_money).toFixed(2) }}<span class="unit">(万)</span></p>
         <p class="item-name">当前列表已回款</p>
       </li>

       <li class="field-item">
         <p class="item-value"> <span class="symbol">¥</span>{{ data.all_no_wait_money == undefined ? '' : Number(data.all_no_wait_money).toFixed(2)}}<span class="unit">(万)</span></p>
         <p class="item-name">未开发票待回款</p>
       </li>

       

     </ul>


     <div class="list-wrapper">

       <div class="list-item" v-for=" item in data.data">

         <div class="row text">
           <span> <span class="title">最后开票时间</span>{{item.last_billed}}</span>
           <span>{{item.region_name}}</span>
         </div>

         <div class="row text">
           <span>{{item.first_party}}</span>
           <span>{{item.group_name}}</span>
         </div>

         <div class="row text">
           <span>{{item.p_name}}</span>
           <!-- <span>制作中</span> -->
         </div>

         <div class="row">

           <div class="row-item">
             <p class="item-value"> <span class="symbol">¥</span>{{ item.b_money == undefined ? '' : (item.b_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
             <p class="item-name">已回款金额</p>
           </div>

           <div class="row-item center">
             <p class="item-value"> <span class="symbol">¥</span>{{ item.y_no_money == undefined ? '' : (item.y_no_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
             <p class="item-name">已开发票待回款金额</p>
           </div>

           <div class="row-item">
             <p class="item-value charge">{{item.sales}}</p>
             <p class="item-name">负责人</p>
           </div>



         </div>
       </div>
       <nodata v-if="!data.data.length"></nodata>

       <div class="zhezhao" v-if="isFilter" @click="cancel"></div>

       <!--筛选-->
       <div class="selbox" v-if="isFilter">
         <p>筛选</p>

         <p class="content">
           时间
         </p>

         <ul class="listtime">
           <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
         </ul>

         <p  class="content">
           区域
         </p>
         <ul  class="listtime">
           <li :class="{'true': index == c_department[0]}" v-for="(item,index) in department" @click="onDepartmentChang(index)" >{{item}}</li>
         </ul>

         <p class="btnyes" @click="confirmFilter">确定</p>
       </div>

     </div>

  </div>
</template>

<script>
import nodata from '../public/nodata'
import '../../assets/css/drillStyle.css'
import slotsList from '../../assets/js/slotsList'
import dateChange from '../../mixins/dateChange.js'
import groupChange from '../../mixins/groupChange.js'

export default {
  mixins:[dateChange,groupChange],
  components:{
    nodata,
  },
  data () {
    return {
      isFilter:false,
      begin_time:null, // 过滤时间
      end_time:null,
      group:[],

      status:{
        0:'待处理',
        1:'开发中',
        2:'已交付',
        3:'已暂停',
        4:'已关闭',
        5:'已完结',
      }, //状态

      data:{ //总体数据
        data:[],
      }

    }
  },
  methods:{
    returnPage () {
      this.$router.go(-1)
    },
    getData (data) {
      this.$notice.loading()
      this.$http.getMakeInvoiceNoBack(data).then( res => {
        this.data =  res.data
        this.$notice.loading(false)
      })
    },

    filter () { //显示过滤
      this.slots = slotsList.Monthslots(this.begin_time,this.end_time)
      this.isFilter = true
      this.$emit('inFilter')
    },

    confirmFilter () { //确定过滤
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      this.group = this.c_department
      let data = {
        begin_time: this.begin_time ,
        end_time: this.end_time,
        group: this.group
      }
      this.isFilter = false
      this.getData(data)
      this.$emit('noFilter')
      //window.localStorage.setItem('drillData',JSON.stringify(data))
    },

    cancel () { //点击阴影取消
      this.c_region = this.region
      this.isFilter = false
      this.$emit('noFilter')
    },
  },
  created () {
    let data =  JSON.parse ( window.localStorage.getItem('drillData') )
    let { begin_time , end_time , group } = data

    this.group = this.c_department = group
    this.begin_time = begin_time
    this.end_time = end_time

    this.getData(data)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/drillPage/MakeHasInvoiceReturnMoneyDrill.vue